import { OvertimeWorkedAndScheduledPerPeriodModel } from "../models/OvertimeSchedule";
import {
  formatDateLabel,
  formatDateLabelWithDay,
  normalizeDateString,
} from "./date.utils";

export interface PeriodRange {
  index: number;
  startDate: string;
  endDate: string;
  dayCount: number;
}

export interface PeriodDate {
  dateKey: string;
  label: string;
}

const getReferenceEmployee = (
  data: OvertimeWorkedAndScheduledPerPeriodModel[],
) => data.find((employee) => (employee.periods?.length ?? 0) > 0);

export const buildPeriodsFromData = (
  data: OvertimeWorkedAndScheduledPerPeriodModel[],
): PeriodRange[] => {
  const reference = getReferenceEmployee(data);
  const weeks = reference?.periods ?? [];

  return weeks.map((week, index) => {
    const sortedDates = (week.days ?? [])
      .map((day) => normalizeDateString(day.date))
      .filter(Boolean)
      .sort((a, b) => a.localeCompare(b));

    const startDate = sortedDates[0] ?? "";
    const endDate = sortedDates[sortedDates.length - 1] ?? "";

    return {
      index,
      startDate,
      endDate,
      dayCount: sortedDates.length,
    };
  });
};

export const getPeriodDatesFromData = (
  data: OvertimeWorkedAndScheduledPerPeriodModel[],
  selectedWeekIndex: number,
): PeriodDate[] => {
  const reference = getReferenceEmployee(data);
  const week = reference?.periods?.[selectedWeekIndex];

  return (week?.days ?? [])
    .map((day) => {
      const dateKey = normalizeDateString(day.date);
      return {
        dateKey,
        label: formatDateLabelWithDay(dateKey),
      };
    })
    .sort((a, b) => a.dateKey.localeCompare(b.dateKey));
};

export const formatPeriodLabel = (period: PeriodRange) => {
  if (!period.startDate || !period.endDate) {
    return `Periodo ${period.index + 1}`;
  }

  const start = new Date(`${period.startDate}T00:00:00`);
  const end = new Date(`${period.endDate}T00:00:00`);

  return `${formatDateLabel(start)} - ${formatDateLabel(end)}`;
};
